import InboundActions from '@intercom/embercom-composer/mixins/inbound-actions';
import ComponentPositioningMixin from '@intercom/embercom-composer/components/mixins/component-positioning';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import $ from 'jquery';
import { reads } from '@ember/object/computed';
import { scheduleOnce } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend(InboundActions, ComponentPositioningMixin, {
  classNames: ['composer-attribute-editor'],
  //TODO: GJ: rename to composer-attribute-inserter
  attributeBindings: ['style'],
  classNameBindings: ['isWithinViewport::is-out-of-view', 'rightPositionOverflowsViewport:ic-mirror-popup'],
  isWithinViewport: reads('selectionCoordinates.isWithinViewport'),
  isMinimized: true,
  attributes: reads('config.attributes'),
  customObjectAttributeGroups: reads('config.customObjectAttributeGroups'),
  top: Em.computed('selectionCoordinates.top', 'selectionCoordinates.height', 'height', function () {
    return this.get('selectionCoordinates.top') + this.get('selectionCoordinates.height') / 2 - this.get('height') / 2;
  }),
  left: Em.computed('editorDimensions.width', 'hoverCoordinates.left', function () {
    return this.get('editorDimensions.width') + this.get('hoverCoordinates.left');
  }),
  style: Em.computed('top', 'left', function () {
    let top = this.get('top');
    let left = this.get('left');
    let style = '';
    if (!this.get('isMinimized')) {
      let verticalOffset = this._verticalOffsetForOverflowParent(top, $(this.element));
      top += verticalOffset;
      this.positionPointer(verticalOffset);
    }
    if (Em.isPresent(top)) {
      style = `top: ${top}px; left:${left}px`;
    }
    return sanitizeHtml(style);
  }),
  didInsertElement() {
    this._super(...arguments);
    scheduleOnce('afterRender', this, this.setDimensions);
  },
  setDimensions() {
    if ($(this.element)) {
      let $el = $('div', this.element).first();
      this.setProperties({
        height: $el.outerHeight(),
        width: $el.outerWidth()
      });
    }
  },
  setOverflowState() {
    if ($(this.element)) {
      let $el = $('div', this.element).first();
      let viewport = $(this.get('viewportSelector'));
      if (viewport.length) {
        let popoverRight = $el[0].getBoundingClientRect().right;
        let viewportRight = viewport[0].getBoundingClientRect().right;
        this.set('rightPositionOverflowsViewport', popoverRight > viewportRight);
      }
    }
  },
  willDestroyElement() {
    this._super(...arguments);
    let enableHoverUpdates = this.get('enableHoverUpdates');
    if (enableHoverUpdates) {
      enableHoverUpdates();
    }
  },
  _setMinimizedState(isMinimized) {
    if (isMinimized) {
      this.get('enableHoverUpdates')();
    } else {
      this.get('disableHoverUpdates')();
    }
    this.set('isMinimized', isMinimized);
    scheduleOnce('afterRender', this, this.setDimensions);
    scheduleOnce('afterRender', this, this.setOverflowState);
  },
  actions: {
    maximize() {
      this._setMinimizedState(false);
    },
    minimize() {
      if (!this.get('isDestroying') && !this.get('isMinimized')) {
        this._setMinimizedState(true);
      }
    },
    insertAttribute(attribute) {
      this.get('insertAttribute')(attribute);
      this._setMinimizedState(true);
    }
  }
});